import { FilterOptions } from 'src/types/FilterOptions'
import { Vehicle } from 'src/types/Vehicle'

export const filterVehiclesBySearch = (vehicles: Vehicle[], searchValue: string) => {
  const search = searchValue.toLowerCase()

  return vehicles.filter((vehicle) => (
    vehicle.vehicle_rego_number.toLowerCase().includes(search) ||
    vehicle.make_name.toLowerCase().includes(search) ||
    vehicle.model_name.toLowerCase().includes(search) ||
    vehicle.VEHICLE_ID.toLowerCase().includes(search)
  ))
}

export const filterVehiclesByOptions = (vehicles: Vehicle[], filterOptions: FilterOptions) => (
  vehicles.filter((vehicle) => {
    const vehicleBrand = vehicle.make_name.toLowerCase() + ' ' + vehicle.model_name.toLowerCase()

    if (filterOptions.make && vehicleBrand !== filterOptions.make.toLowerCase()) {
      return false
    }

    if (filterOptions.pickupLocation && vehicle.LOCATION_ID !== filterOptions.pickupLocation) {
      return false
    }

    if (filterOptions.range && vehicle.vehicle_range_km !== '0' && parseInt(vehicle.vehicle_range_km) < filterOptions.range) {
      return false
    }

    if (filterOptions.seats && vehicle.vehicle_nr_seats && vehicle.vehicle_nr_seats !== '0' && parseInt(vehicle.vehicle_nr_seats) < parseInt(filterOptions.seats)) {
      return false
    }

    if (filterOptions.luggages && vehicle.vehicle_nr_luggage && vehicle.vehicle_nr_luggage !== '0' && parseInt(vehicle.vehicle_nr_luggage) < parseInt(filterOptions.luggages)) {
      return false
    }

    if (filterOptions.fuelType && vehicle.vehicle_fuel.toLowerCase() !== filterOptions.fuelType.toLowerCase()) {
      return false
    }

    if (filterOptions.transmission && vehicle.vehicle_transmission.toLowerCase() !== filterOptions.transmission.toLowerCase()) {
      return false
    }

    if (filterOptions.attributes && filterOptions.attributes.length > 0 && !filterOptions.attributes.every(attr => vehicle.vehicle_attribute_names.toLowerCase().includes(attr.toLowerCase()))) {
      return false
    }

    if (filterOptions.features && filterOptions.features.length > 0 && !filterOptions.features.every(feature => vehicle.vehicle_feature_names.toLowerCase().includes(feature.toLowerCase()))) {
      return false
    }

    if (filterOptions.favouritesOnly && !vehicle.isLiked) {
      return false
    }

    return true
  })
)
